
import React from "react";
import { Button } from "@/components/ui/button";
import { MoreVertical } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent
} from "@/components/ui/dropdown-menu";

interface TableActionMenuProps<T> {
  item: T;
  render: (item: T) => React.ReactNode;
}

function TableActionMenu<T>({ item, render }: TableActionMenuProps<T>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <MoreVertical className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {render(item)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default TableActionMenu;
